import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../../commons/services/common.service';

@Component({
  selector: 'app-icons-decheterie',
  templateUrl: './icons-decheterie.component.html',
  styleUrls: ['./icons-decheterie.component.css']
})
export class IconsDecheterieComponent implements OnInit {
  @Input() icon;
  @Input() couleur;
  user: any = {};

  constructor(public common: CommonService) { }

  ngOnInit() {
    this.user = this.common.local.getObject('clientLogin') ||  {};
    const stylePageEcoportail  = this.common.local.getObject('stylePageEcoportail') ||  {};
    const couleur = stylePageEcoportail.couleur;
    if (!this.couleur) {
      this.couleur = this.user['couleur'] !== '' ? this.user['couleur'] : couleur;
    }
  }

}
